import { render, staticRenderFns } from "./Policy.Detail.vue?vue&type=template&id=1f952054&"
import script from "./Policy.Detail.vue?vue&type=script&lang=js&"
export * from "./Policy.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports